/** Custom events for VOD basic editors (toolbar → page modals). */
export const VOD_CREATE_MOVIE_EVENT = 'iptv-vod-create-movie';
export const VOD_CREATE_SERIES_EVENT = 'iptv-vod-create-series';

export function dispatchVodCreateMovie(): void {
  window.dispatchEvent(new CustomEvent(VOD_CREATE_MOVIE_EVENT));
}

export function dispatchVodCreateSeries(): void {
  window.dispatchEvent(new CustomEvent(VOD_CREATE_SERIES_EVENT));
}
